<script>
    import { supabase } from "./supabaseClient.js";
    import { onMount } from "svelte";

    let { slot } = $props();

    let appuntamenti = $state([]);
    let output = $state([]);
    let loading = $state(true);
    let error = $state(null);

    export const sleep = (ms) =>
        new Promise((resolve) => setTimeout(resolve, ms));

    const saveSlot = async (line, name) => {
        error = null;
        loading = true;
        if (line.id) {
            if (
                confirm("Sei sicuro di voler modificare questa prenotazione?")
            ) {
                // Update existing appointment
                const { data, error: updateError } = await supabase
                    .from("appuntamenti")
                    .update({ name })
                    .eq("id", line.id);

                if (updateError) {
                    error = updateError.message;
                    console.error("Error updating appointment:", updateError);
                } else {
                    console.log("Appointment updated:", data);
                }
            }
        } else {
            // Insert new appointment
            const { data, error: insertError } = await supabase
                .from("appuntamenti")
                .insert([{ date: slot.date, time: line.time, name }]);

            if (insertError) {
                error = insertError.message;
                console.error("Error inserting appointment:", insertError);
            } else {
                console.log("Appointment inserted:", data);
            }
        }
        await sleep(1500); // Small delay to ensure DB consistency
        await getData();
    };

    const mergeData = () => {
        let startTime = new Date(`${slot.date} ${slot.start}`);
        console.log(appuntamenti, slot)
        const newOutput = [];
        for (let i = 0; i < slot.slots; i += 1) {
            const time = new Intl.DateTimeFormat("it-IT", {
                hour: "2-digit",
                minute: "2-digit",
            }).format(new Date(startTime));
            newOutput.push({
                time,
                name: (() =>
                    appuntamenti.find((a) => a.time === time && a.date === slot.date)?.name || "")(),
                id: (() =>
                    appuntamenti.find((a) => a.time === time && a.date === slot.date)?.id || "")(),
            });
            startTime = new Date(startTime.getTime() + slot.duration);
        }
        output = newOutput;
    };

    const getData = async () => {
        appuntamenti = [];
        output = []; // Clear output array
        const { data, error: fetchError } = await supabase
            .from("appuntamenti")
            .select("*")
            .eq("date", new Date(slot.date).toISOString().split("T")[0])
            .order("created_at", { ascending: false });

        if (fetchError) {
            error = fetchError.message;
            console.error("Error:", fetchError);
        } else {
            appuntamenti = data || [];
            mergeData();
        }
        loading = false;
    };

    onMount(async () => {
        await getData();
    });
</script>

<div class="slot">
    {#if loading}
        <p>Carico gli appuntamenti...</p>
    {:else if error}
        <p>Errore: <code>{error}</code></p>
    {:else}
        <ul>
            {#each output as line, index}
                <li>
                    <form
                        id="form-{index}"
                        onsubmit={() => {
                            saveSlot(
                                line,
                                document
                                    .querySelector(`#name-${index}`)
                                    .value.trim(),
                            );
                        }}
                    >
                        <input type="hidden" name="time" value={line.time} />
                        <input type="hidden" name="id" value={line.id} />
                        <input type="hidden" name="name" value={line.name} />
                        <div class="time">{line.time}</div>
                        <div class="name">
                            <input
                                type="text"
                                name="name"
                                id="name-{index}-{slot.date}"
                                value={line.name}
                                size="20"
                                placeholder="Inserisci il nome"
                                readonly={slot.open === false}
                            />
                        </div>
                        <div class="button">
                            <button
                                type="button"
                                onclick={() => {
                                    saveSlot(
                                        line,
                                        document
                                            .querySelector(`#name-${index}-${slot.date}`)
                                            .value.trim(),
                                    );
                                }}
                                readonly={!slot.open}
                                disabled={!slot.open}
                                >{line.name ? "Modifica" : "Prenota"}</button
                            >
                        </div>
                    </form>
                </li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .slot {
        min-height: 300px;
    }

    ul,
    li {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    li form {
        display: grid;
        grid-template-columns: 60px auto 100px;
    }

    li input[type="text"] {
        width: 90%;
        padding: 5px;
        font-size: 1em;
    }
</style>
